import { render, staticRenderFns } from "./rianbow.vue?vue&type=template&id=454ae48b&scoped=true&"
import script from "./rianbow.vue?vue&type=script&lang=js&"
export * from "./rianbow.vue?vue&type=script&lang=js&"
import style0 from "./rianbow.vue?vue&type=style&index=0&id=454ae48b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ae48b",
  null
  
)

export default component.exports